import React, {useEffect} from "react";
import {Alert, Box, Button, Grid, TextField} from "@mui/material";
import {Controller, useFormContext} from "react-hook-form";
import {Checkbox, FormControlLabel, Typography} from "@material-ui/core";
import {postData} from "../util/__fetch";
import Paper from "@mui/material/Paper";
import EditableDropdown from "../core/EditableDropdown";
import {hasActiveUsers} from "../util/constant";
import ATSnackbar from "../layout/ATSnackbar";
import FNOUsers from "./FNOUsers";

const strikeLegs = [
  {optionType: "PE", transactionType: "BUY"},
  {optionType: "PE", transactionType: "SELL"},
  {optionType: "CE", transactionType: "SELL"},
  {optionType: "CE", transactionType: "BUY"},
];

const FNOIronCondor = ({shrinkProp, user, selectedIndex, wm, open, setOpen, cePeStrikes}) => {
  const straddleIndex = 0;
  const {
    register, control, getValues, setValue,
    clearErrors, formState: {errors},
    trigger, watch
  } = useFormContext(); // retrieve all hook methods
  const [, setIsLoading] = React.useState(false);
  const [strikeMessage, setStrikeMessage] = React.useState(null);
  const [successMessage, setSuccessMessage] = React.useState(null);
  const [attachBuyLegs, setAttachBuyLegs] = React.useState(true);
  const [selectedUsers, setSelectedUsers] = React.useState([]);
  const [allUsers, setAllUsers] = React.useState([]);
  const strikes = ['ic.PE.BUY', 'ic.CE.BUY', 'ic.PE.SELL', 'ic.CE.SELL'];

  const setResponse = (data) => {
    if (data && data?.status === "success") {
      setSuccessMessage(data?.message);
      setOpen(true);
    }
  };
  const setErrorMessage = (error) => {
    // console.log("set error", error);
    wm(error?.message);
    setOpen(true);
  };

  const ceSellStrike = watch("ic.CE.SELL.strike");
  const peSellStrike = watch("ic.PE.SELL.strike");
  useEffect(() => {
    if (getValues("ic.CE.SELL.strike") && getValues("ic.PE.SELL.strike")
      && (getValues("ic.CE.SELL.strike") < getValues("ic.PE.SELL.strike"))) {
      setStrikeMessage("CE strike should be greater than PE strike for SELL");
    } else {
      setStrikeMessage(null)
    }
  }, [ceSellStrike, peSellStrike, getValues])

  const validate = () => {
    // if any sell strike has value then SL is mandatory else its not
    const value = getValues("ic.slPercentage");
    const sellStrikes = ['ic.PE.SELL.strike', 'ic.CE.SELL.strike'];
    const hasSellStrike = sellStrikes.some(strike => getValues(strike) !== "");
    return hasSellStrike ? !!value : true;
  }
  const placeStraddleSell = (event) => {
    event.preventDefault();
    clearErrors();
    setStrikeMessage("")
    setSuccessMessage("")
    wm("")

    if (!hasActiveUsers(selectedUsers, setStrikeMessage, setOpen)) {
      return;
    }
    if (!selectedIndex || selectedIndex === "") {
      setStrikeMessage("Please select index")
      setOpen(true)
      return;
    }
    const straddle = [
      {
        "strike": "ATM_STRIKE",
        "quantity": getValues(`ic.CE.SELL.quantity`) === "" ? 1 : getValues(`ic.CE.SELL.quantity`),
        "optionType": 'CE',
        "tradeAction": 'SELL'
      },
      {
        "strike": "ATM_STRIKE",
        "quantity": getValues(`ic.PE.SELL.quantity`) === "" ? 1 : getValues(`ic.PE.SELL.quantity`),
        "optionType": 'PE',
        "tradeAction": 'SELL'
      },
    ];
    const activeUserIds = Array.isArray(selectedUsers)
      ? selectedUsers.filter(u => u.active).map(u => u.userId).join(',')
      : '';
    const requestBody = {
      "ironCondorLegs": straddle,
      "slPercentage": getValues("ic.slPercentage"),
      "portfolioAmountPercentage": getValues("ic.portfolioAmountPercentage"),
      "lots": getValues("ic.lots"),
      "selectedUsersCsv": activeUserIds,
      "attachBuyLegs": false,
    };
    console.log('Request body for straddle', requestBody);
    postData(`/algo-trading/api/fno/config/iron-candle/FNO_IRON_CONDOR/${selectedIndex}`, user, requestBody, setResponse, setErrorMessage, setIsLoading);
  }
  const placeIronCondor = (event) => {
    event.preventDefault();
    clearErrors();
    setStrikeMessage("")
    setSuccessMessage("")
    wm("")

    if (!hasActiveUsers(selectedUsers, setStrikeMessage, setOpen)) {
      return;
    }
    if (!selectedIndex || selectedIndex === "") {
      setStrikeMessage("Please select index")
      setOpen(true)
      return;
    }

    clearErrors();
    setStrikeMessage(null)
    console.log(event.target.value);

    if (!selectedIndex || selectedIndex === "") {
      wm("Please select index");
      setOpen(true);
      return;
    }
    // if all are empty then return
    if (strikes.every(strike => getValues(strike + ".strike") === "" || getValues(strike + ".strike") === undefined)) {
      setStrikeMessage("At least one strike should be entered");
      return;
    }
    // check when any of strike is entered, then ratio should be entered
    if (strikes.filter(strike => getValues(strike + ".strike")).length > 0
      && strikes.some(strike => getValues(strike + ".strike") && getValues(strike + ".quantity") === "")) {
      setStrikeMessage("Enter ratio for selected strikes");
      return;
    }
    // if a ratio is entered, then strike should be entered
    if (strikes.filter(strike => getValues(strike + ".quantity")).length > 0
      && strikes.some(strike => getValues(strike + ".quantity") && !getValues(strike + ".strike"))) {
      setStrikeMessage("Enter strike for selected ratio");
      return;
    }

    trigger()
      .then(function (isValid) {
        if (isValid) {
          const multiLegs = [];
          strikeLegs
            .filter(leg => getValues(`ic.${leg.optionType}.${leg.transactionType}.strike`) !== "")
            .filter(leg => getValues(`ic.${leg.optionType}.${leg.transactionType}.quantity`) > 0)
            .map(leg => ({
              "strike": getValues(`ic.${leg.optionType}.${leg.transactionType}.strike`),
              "quantity": getValues(`ic.${leg.optionType}.${leg.transactionType}.quantity`) === "" ? 1 : getValues(`ic.${leg.optionType}.${leg.transactionType}.quantity`),
              "optionType": leg.optionType,
              "tradeAction": leg.transactionType
            }))
            .forEach(leg => multiLegs.push(leg));

          const activeUserIds = Array.isArray(selectedUsers)
            ? selectedUsers.filter(u => u.active).map(u => u.userId).join(',')
            : '';
          const requestBody = {
            "ironCondorLegs": multiLegs,
            "slPercentage": getValues("ic.slPercentage"),
            "portfolioAmountPercentage": getValues("ic.portfolioAmountPercentage"),
            "lots": getValues("ic.lots"),
            "selectedUsersCsv": activeUserIds,
            "attachBuyLegs": attachBuyLegs,
          };
          console.log(getValues("ic"), 'request:', requestBody);

          postData(`/algo-trading/api/fno/config/iron-candle/FNO_IRON_CONDOR/${selectedIndex}`, user, requestBody, setResponse, setErrorMessage, setIsLoading);
        } else {
          console.log('invalid');
        }
      })
  }

  function row(control, shrinkProp, straddleIndex, index, optionType, transactionType) {
    const optionBasedColor = "PE" === optionType ? "white" : "black";
    const textStyleBasedLabelOnOptionType = {color: optionBasedColor, borderColor: optionBasedColor};
    const textStyleBasedOnOptionType = {color: optionBasedColor, borderColor: optionBasedColor, fontSize: "1.3rem" };
    const textFieldProps = {
      label: "Strike",
      variant: "outlined",
      size: "small",
      InputLabelProps: {shrink: true, style: textStyleBasedLabelOnOptionType},
      InputProps: {style: textStyleBasedOnOptionType},
    };
    // form this from ltp price and selected index
    // for a index get the strike gap and then calculate the strikes based on the index ltp
    // +5 strikes and -5 strikes
    const fieldName = `ic.${optionType}.${transactionType}.strike`;
    const options = transactionType === "SELL"
      ? (optionType === "CE" ? cePeStrikes?.ceStrikes : cePeStrikes?.peStrikes) : [];

    return (
      <Box display="flex" justifyContent="space-between" m={1}>
        <Grid container item spacing={2}>
        <Grid item xs={1} sm={1} md={1}>
          <Typography>{optionType}</Typography>
        </Grid>
        <Grid item xs={5} sm={4} md={6} lg={4}>
          <Controller
            name={fieldName}
            control={control}
            render={({field}) => (
              <EditableDropdown
                options={options}
                value={field.value}
                onChange={strike => {
                  const trimmedStrike = strike ? strike.toString().trim() : "";
                  field.onChange(trimmedStrike);
                  // Set Ratio textfield to 1 if blank
                  const quantityField = `ic.${optionType}.${transactionType}.quantity`;
                  if (!trimmedStrike) {
                    setValue(quantityField, "");
                  }
                  else if (!getValues(quantityField)) {
                    setValue(quantityField, 1);
                  }
                }}
                {...textFieldProps}
              />
            )}
          />
        </Grid>
        <Grid item xs={5} sm={3} md={3}>
          <TextField label="Ratio" variant="outlined" size="small"
                     InputLabelProps={{shrink: true, style: textStyleBasedLabelOnOptionType}}
                     InputProps={{style: textStyleBasedOnOptionType}}
                     {...register(`ic.${optionType}.${transactionType}.quantity`)} />
        </Grid>
        <Grid item xs={5} sm={4} md={1}>
          <Typography>{transactionType}</Typography>
        </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <Grid item container xs={12} md={12} spacing={2}>
      <Grid item xs={12} md={6} lg={12}>
        <Paper elevation={1} sx={{padding: 1}}>
          <Grid item xs={12} md={12} lg={6}>
            <FNOUsers user={user}
                      selectedUsers={selectedUsers}
                      setSelectedUsers={setSelectedUsers}
                      allUsers={allUsers}
                      setAllUsers={setAllUsers}
                      setErrorMessag={wm}
                      type={"SELL"}
            />
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
      <Paper elevation={1} sx={{overflow: 'hidden', padding: 2}}>
        <Grid item xs={12} md={12}>
          <Typography variant="h6" gutterBottom>Iron Condor</Typography>
        </Grid>
        {strikeMessage && <Grid item xs={12} md={12}>
          <Alert severity="warning" variant="outlined">{strikeMessage}</Alert>
        </Grid>}
        {successMessage && <Grid item xs={12} md={12}>
          <ATSnackbar message={successMessage} open={open} setOpen={setOpen} severity="success"/>
        </Grid>}
        <Grid container item spacing={2}>
          <Grid container item xs={12} md={8.5} flexDirection="row" spacing={2}>
            <Grid item>
              <Paper component={Grid} item elevation={4}
                     style={{padding: 1, paddingRight: 2, margin: 2, backgroundColor: "lightgreen"}}>
                {row(control, shrinkProp, straddleIndex, 3, "CE", "BUY")}
                {row(control, shrinkProp, straddleIndex, 2, "CE", "SELL")}
              </Paper>
            </Grid>
            <Grid item>
              <Paper component={Grid} item elevation={4}
                     style={{padding: 1, paddingRight: 2, margin: 2, backgroundColor: "orangered", color: "white"}}>
                {row(control, shrinkProp, straddleIndex, 1, "PE", "SELL")}
                {row(control, shrinkProp, straddleIndex, 0, "PE", "BUY")}
              </Paper>
            </Grid>
          </Grid>
          <Grid container item xs={12} md={12} lg={3}  flexDirection={"row"} spacing={2}>
            <Grid item>
              <FormControlLabel
                control={<Checkbox checked={attachBuyLegs} onChange={(e) => setAttachBuyLegs(e.target.checked)} />}
                label="Attach Buy">
              </FormControlLabel>
            </Grid>
            <Grid item xs={12} md={12} lg={8}>
              <TextField label="% Prtf Amt" variant="outlined" size="small"
                         InputLabelProps={shrinkProp}
                         defaultValue={20}
                         error={!!errors?.['ic']?.['portfolioAmountPercentage']}
                         helperText={errors?.['ic']?.['portfolioAmountPercentage'] && '% required'}
                         {...register(`ic.portfolioAmountPercentage`, {validate: validate})} />
            </Grid>
            <Grid item xs={12} md={12} lg={8}>
              <TextField label="Lots" variant="outlined" size="small"
                         InputLabelProps={shrinkProp}
                         error={!!errors?.['ic']?.['lots']}
                         helperText={errors?.['ic']?.['lots'] && '% required'}
                         {...register(`ic.lots`, {validate: validate})} />
            </Grid>
            <Grid item xs={12} md={12} lg={8}>
              <TextField label="SL%" variant="outlined" size="small"
                         InputLabelProps={shrinkProp}
                         error={!!errors?.['ic']?.['slPercentage']}
                         helperText={errors?.['ic']?.['slPercentage'] && 'SL% required'}
                         defaultValue={10}
                         {...register(`ic.slPercentage`, {validate: validate})} />
            </Grid>
            <Grid item>
              <Button variant="contained" size="small" value="FNO_IRON_CONDOR" onClick={placeIronCondor}>Place
                Trade</Button>
            </Grid>
            <Grid item>
              <Button variant="contained" size="small" value="FNO_STRADDLE_SELL" onClick={placeStraddleSell}>Place
                Straddle</Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      </Grid>
    </Grid>
  );
};

export default FNOIronCondor;